import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useEffect, useState } from 'react'

const TabPanel = (props) => {
	const { children, value, index, noPadding, ...other } = props
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{
					paddingTop: 3,
					paddingBottom: 3,
					paddingLeft: noPadding ? 0 : 2,
					paddingRight: noPadding ? 0 : 2,
				}}>
					{children}
				</Box>
			)}
		</div>
	)
}

const BasicTabs = ({ data, setValues }) => {
	const [tempData, setTempData] = useState([])
	const [value, setValue] = useState(0)

	const handleChange = (event, newValue) => {
		if (setValues) setValues(newValue)
		setValue(newValue)
	}

	useEffect(() => {
		if (data && data.length > 0) {
			setTempData(data)
		}
	}, [data])

	// Renderujemy tylko jeśli mamy dane
	if (!tempData || tempData.length === 0) return null

	return (
		<Box sx={{ width: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs
					value={value}
					onChange={handleChange}
					scrollButtons="auto"
					variant="standard"
				>
					{tempData.map((el, index) => (
						<Tab key={index} label={el?.name} />
					))}
				</Tabs>
			</Box>
			{tempData.map((el, index) => (
				<TabPanel key={index} value={value} index={index} noPadding={el.noPadding}>
					<Box>
						{typeof el.value === 'function' ? el.value() : el.value}
					</Box>
				</TabPanel>
			))}
		</Box>
	)
}

export default BasicTabs
